import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { getPublicationCountPerType } from "../../../../state/selectors/Publications.selectors";
import { getQueryType } from "../../../../state/selectors/general.selectors";
import CardWrapper from "../../CardWrapper";
import Card from "../../Card";
import tailwindColors from "../../../../../../tailwind.colors";
import PublicationsCardContent from "./PublicationsCardContent";

function PublicationsCard({ card }) {
  return (
    <CardWrapper
      {...card}
      color={tailwindColors.blue[500]}
      humanTitle={card.title}
      title={
        <div className="tw-flex tw-items-baseline">
          <span className="tw-mr-1">{card.title}</span>
          <i className="fa fa-file-text-o tw-text-blue-500" />
        </div>
      }
    >
      <PublicationsCardContent />
    </CardWrapper>
  );
}

PublicationsCard.propTypes = {
  card: PropTypes.instanceOf(Card).isRequired,
  publicationCounts: PropTypes.shape({
    variant: PropTypes.number,
    gene: PropTypes.number,
    region: PropTypes.number,
  }),
  queryType: PropTypes.string,
};

PublicationsCard.defaultProps = {
  publicationCounts: {
    variant: 0,
    gene: 0,
    region: 0,
  },
  queryType: null,
};

const mapStateToProps = (state) => ({
  publicationCounts: getPublicationCountPerType(state),
  queryType: getQueryType(state),
});

export default connect(mapStateToProps)(PublicationsCard);
